import { ClientReferenceNumberType, GLCode } from '@rygen/rygen-ui/model';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'reference-number-type';

export class ReferenceNumberTypeController extends BaseHttpController {
  constructor() {
    super(endpoint, { canIncludeSubDomains: true });
  }

  async findAllTypes(): Promise<ClientReferenceNumberType[]> {
    const response = await this.http.get<ClientReferenceNumberType[]>('');
    return response.data.map((val) => new ClientReferenceNumberType(val));
  }

  async findAllShipmentTypes(): Promise<ClientReferenceNumberType[]> {
    const response =
      await this.http.get<ClientReferenceNumberType[]>('shipment');
    return response.data.map((val) => new ClientReferenceNumberType(val));
  }

  async findAllOrderTypes(): Promise<ClientReferenceNumberType[]> {
    const response = await this.http.get<ClientReferenceNumberType[]>('order');
    return response.data.map((val) => new ClientReferenceNumberType(val));
  }

  async findAllLineItemTypes(): Promise<ClientReferenceNumberType[]> {
    const response =
      await this.http.get<ClientReferenceNumberType[]>('line-item');
    return response.data.map((val) => new ClientReferenceNumberType(val));
  }

  async findAllGlCodes(): Promise<GLCode[]> {
    const response = await this.http.get<GLCode[]>('gl-code');
    return response.data.map((val) => new GLCode(val));
  }
}
